import React, { useContext, useEffect, useRef } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getAdvertisingTargeting, getIsSkiSeason, getScreenMeta } from 'redux-state/layout/selectors.js';
import { TrackingContext } from './tracking.js';

/** Manages Updating of Nielsen Tracking sends whenever new url is sent */
export const NielsenTrackerHook = ({ children }: { children: React.ReactNode }): React.ReactNode => {
  const currentUrl = useLocation().pathname;
  const { nielsenTrack } = useContext(TrackingContext);
  const screenMeta = useSelector(getScreenMeta, shallowEqual);
  const isSkiSeason = useSelector(getIsSkiSeason);
  const adTargeting = useSelector(getAdvertisingTargeting);
  const screenMetaRef = useRef(screenMeta);
  const isSkiSeasonRef = useRef(isSkiSeason);
  const adTargetingRef = useRef(adTargeting);

  useEffect(() => {
    screenMetaRef.current = screenMeta;
    isSkiSeasonRef.current = isSkiSeason;
    adTargetingRef.current = adTargeting;
  }, [screenMeta, isSkiSeason, adTargeting]);

  useEffect(() => {
    if (Object.keys(screenMetaRef.current).length) {
      nielsenTrack({
        pathname: currentUrl,
        isSkiSeason: isSkiSeasonRef.current,
        targeting: adTargetingRef.current?.staticData,
      });
    }
  }, [currentUrl, nielsenTrack]);

  return children;
};
